import React from 'react'
import './faq.css'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Box, Button } from "@mui/material";
import { DARKCOLORS, LIGHTCOLORS } from "../../../Utils/constants.js";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { blue } from '@mui/material/colors';
import { useThemeContext } from '../../../Context/ThemeContext.js';
import { useEffect } from 'react';

const Faq = () => {
  const { mode } = useThemeContext();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const containerBG = mode === "dark" ? DARKCOLORS.BackgroundMenu : LIGHTCOLORS.BackgroundMenu;
  const btnBG = mode === "dark" ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
  const textColor = mode === 'dark' ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.DisabledLightBackground;
  const backgroundCard = mode === 'dark' ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;
  const subtitletext = mode === 'dark' ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.GreyScale60;
  // const titletext = mode === 'dark' ? DARKCOLORS. : LIGHTCOLORS.GreyScale10;
  const headingcolor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
  const linkcolor= mode === 'dark' ? DARKCOLORS.Primary500: LIGHTCOLORS.Primary500;
 

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);




  return (
    <div className='faq-container'
      style={{
        backgroundColor: containerBG,
        borderRadius: "10px",
        // margin: "20px 10px",
        width: "100%",
      }}>
      <div className='faq-sec'


      >
        <Box className="back-btn-sec" style={{ display: 'flex', position: 'relative', left: '-10px', alignItems: 'end', }}>
          <Button className="back-btn"
            onClick={() => navigate("/help")}
            sx={{
              width: 38,
              height: 38,
              padding: 0,

              borderRadius: "50%",
              bgcolor: btnBG,
              minWidth: "unset",  // Prevents default min-width in MUI
              // "&:hover": { bgcolor: backgroundCard}  // Adds hover effect
            }}
          >
            <KeyboardBackspaceIcon sx={{ color: linkcolor }} />
          </Button>
          <h2 className="back-btn-text" style={{ marginBottom: '0', marginLeft: '10px' }}>Back</h2>
        </Box>
        <Box className='faq-sec'>
          <p className='faq-title' style={{ color:  headingcolor }}> {t('help.AskedQuestions')}</p>
          <Box className="login-sec box-spacing">

            <p className='faq-subtitle trust-terms'>{t('help.AskedQuestionssubTitle')}</p>
            <Box className="question-box">
              <p style={{ color: headingcolor }} className='question' > 1. {t('help.AskedQuestions1')}</p>
              <p className='answer-box' style={{ color: subtitletext }} >{t('help.goto')} <a href="https://naf-cloudsystem.de/" style={{color:linkcolor}}> {t('help.link')}</a> {t('help.AskedAnwser1')}</p>
            </Box>
            <Box className="question-box">
              <p style={{ color: headingcolor }} className='question' > 2. {t('help.AskedQuestions2')}</p>
              <p className='answer-box' style={{ color: subtitletext }} >{t('help.AskedAnwser2')}</p>
            </Box>
            <Box className="question-box">
              <p style={{ color: headingcolor }} className='question' > 3. {t('help.AskedQuestions3')}</p>
              <p  className='answer-box'style={{ color: subtitletext }} >{t('help.AskedAnwser3')}</p>
            </Box>
          </Box>






          <Box className="navigation-sec box-spacing" >

            <p className='faq-subtitle trust-terms'>{t('help.NavigationDashboard')}</p>

            <Box className="question-box">
              <p style={{ color: headingcolor }} className='question' > 1. {t('help.navigationAskedQuestions1')}</p>
              <p style={{ color: subtitletext }} className='answer-box' >{t('help.navigationAskedAnwser1')}</p>
            </Box>

            <Box className="question-box">
              <p style={{ color: headingcolor }} className='question' > 2. {t('help.navigationAskedQuestions2')}</p>
              <p style={{ color: subtitletext }} className='answer-box' >{t('help.navigationAskedAnwser2')}</p>
            </Box>
          </Box>
          

          <Box  className="Data-reporting-box box-spacing">
          <p className='faq-subtitle trust-terms'>{t('help.navigationAskedAnwser2')}</p>
            <Box className="question-box">
              <p style={{ color: headingcolor }} className='question' >1. {t('help.DataReportingAskedQuestions1')}</p>
              <p style={{ color: subtitletext }}  className='answer-box'> {t('help.DataReportingAskedAnwser1')}</p>
            </Box>
            <Box className="question-box">
              <p style={{ color: headingcolor }} className='question' >2. {t('help.DataReportingAskedQuestions2')}</p>
              <p style={{ color: subtitletext }}  className='answer-box'>{t('help.DataReportingAskedAnwser2')}</p>
            </Box>

            <Box className="question-box">
              <p style={{ color: headingcolor }} className='question' > 3. {t('help.DataReportingAskedQuestions3')}</p>
              <p style={{ color: subtitletext }}  className='answer-box'> {t('help.DataReportingAskedAnwser3')}</p>
            </Box>
            <Box className="question-box">
              <p style={{ color: headingcolor }} className='question' > 4. {t('help.DataReportingAskedQuestions4')}</p>
              <p style={{ color: subtitletext }} className='answer-box' >{t('help.DataReportingAskedAnwser4')}</p>
            </Box>

          </Box>

          
          <Box  className="maintain-box box-spacing">
          <p className='faq-subtitle trust-terms'>{t('help.MaintenanceServiceRequests')}</p>
            <Box className="question-box">
              <p style={{ color: headingcolor }} className='question' >1. {t('help.MaintenanceServiceRequestsAskedQuestions1')}</p>
              <p style={{ color: subtitletext }} className='answer-box' > {t('help.MaintenanceServiceRequestsAskedAnwser1')}</p>
            </Box>
            <Box className="question-box">
              <p style={{ color: headingcolor }} className='question' >2. {t('help.MaintenanceServiceRequestsAskedQuestions2')}</p>
              <p style={{ color: subtitletext }} className='answer-box' >{t('help.MaintenanceServiceRequestsAskedAnwser2')}</p>
            </Box>

          </Box>
          <Box  className="others-box box-spacing">
            <p className='faq-subtitle trust-terms'>{t('help.Other')}</p>
              <Box className="question-box">
                <p style={{ color: headingcolor }} className='question' > 1. {t('help.MaintenanceServiceRequestsAskedQuestions3')}</p>
                <p style={{ color: subtitletext }} className='answer-box' >{t('help.MaintenanceServiceRequestsAskedAnwser3')}</p>
              </Box>
              <Box className="question-box">
                <p style={{ color: headingcolor }} className='question' >2. {t('help.MaintenanceServiceRequestsAskedQuestions4')}
                </p>
                <p style={{ color: subtitletext }} className='answer-box'>
                  {t('help.MaintenanceServiceRequestsAskedAnwser4').split('https://www.vendinaf.com/de/support').map((part, i, arr) => (
                    <React.Fragment key={i}>
                      {part}
                      {i < arr.length - 1 && (
                        <a href="https://www.vendinaf.com/de/support" style={{color:linkcolor}}>
                          Support Form
                        </a>
                      )}
                    </React.Fragment>
                  ))}
                </p>
              </Box>

          </Box>


        </Box>
      </div>


    </div >
  )
}

export default Faq